"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var normalize = (0, _styledComponents.css)(["", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.fontFiles.map(function (fontFile) {
    return (0, _styledComponents.css)(["@font-face{font-family:'", "';src:local('", "'),url('", "", "", ".", "') format('", "');font-style:normal;font-weight:", ";font-display:swap;}"], theme.fonts.family, fontFile.file, theme.baseAssetLocation, theme.assetLocations.fonts, fontFile.file, theme.fonts.extension, theme.fonts.extension, fontFile.weight);
  });
});
var _default = normalize;
exports["default"] = _default;
//# sourceMappingURL=fontFace.js.map